module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_list_arrow-c925c7b4318601e272f1a7d30ebd73a4.svg";